import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import isClient from 'commons/isClient';
const useSetCSSVariables = variablesToUpdate => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== variablesToUpdate) {
    t0 = () => {
      Object.entries(variablesToUpdate).forEach(_temp);
    };
    t1 = [variablesToUpdate];
    $[0] = variablesToUpdate;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useSetCSSVariables;
function _temp(t0) {
  const [key, value] = t0;
  if (isClient()) {
    document.documentElement.style.setProperty(key, value);
  }
}